<template>
  <el-row>
    <el-col :span="24">
      <div
        class="logo-container"
        @click="backToHome"
        :title="$route.name === 'home' ? '点击刷新数据' : ''"
      >
        <!-- <i class="el-icon-eleme blue"></i> -->
        <img
          src="../../assets/img/washinglogo.png"
          class="washinglogo"
          alt=""
        />
        <span>后台管理系统</span>
      </div>
      <el-menu
        :default-active="activeIndex"
        class="el-menu-vertical-demo"
        :background-color="getMenuBgcolor()"
        text-color="#fff"
        active-text-color="#ffd04b"
        :unique-opened="false"
        :router="true"
      >
        <template v-for="item in activeMenuList">
          <el-submenu v-if="item.children" :key="item.name" :index="item.name">
            <template slot="title">
              <i :class="[item.icon]"></i>
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item
              v-for="subItem in item.children"
              :key="subItem.name"
              :index="subItem.path"
            >
              <i :class="[subItem.icon]"></i>
              <span slot="title">{{ subItem.name }}</span>
              <span slot="title"></span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else :index="item.path" :key="item.name">
            <i :class="[item.icon]"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-col>
    <div class="mask"></div>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      //管理员菜单
      menuList: [
        {
          name: "订单管理",
          icon: "el-icon-files",
          children: [
            {
              name: "订单查询",
              path: "/order",
              icon: "el-icon-tickets"
            },
            {
              name: "支付记录",
              path: "/payment",
              icon: "el-icon-bank-card"
            },
            {
              name: "退款审核",
              path: "/refund",
              icon: "el-icon-edit"
            }
          ]
        },

        {
          name: "设备管理",
          icon: "el-icon-cpu",
          children: [
            {
              name: "设备设置",
              path: "/machine",
              icon: "el-icon-printer"
            },
            {
              name: "产品模板",
              path: "/product",
              icon: "el-icon-data-board"
            },
            {
              name: "产品绑定",
              path: "/bindproduct",
              icon: "el-icon-connection"
            },
            {
              name: "故障管理",
              path: "/fault",
              icon: "el-icon-warning"
            },
            {
              name: "加液管理",
              path: "/Liquid",
              icon: "el-icon-s-operation"
            },
            {
              name: "企鹅加液",
              path: "/LiquidFeeder",
              icon: "el-icon-data-analysis"
            },
            {
              name: "心跳设置",
              path: "/heartbeat",
              icon: "el-icon-lightning"
            },
            {
              name: "离线日志",
              path: "/machineOfflineLog",
              icon: "el-icon-sort"
            },
            {
              name: "上报消息",
              path: "/notifyMessage",
              icon: "el-icon-connection"
            }
          ]
        },

        {
          name: "加盟管理",
          icon: "el-icon-film",
          children: [
            {
              name: "总代管理",
              path: "/agent",
              icon: "el-icon-s-flag"
            },
            {
              name: "加盟管理",
              path: "/joinIn",
              icon: "el-icon-connection"
            },
            {
              name: "门店管理",
              path: "/shop",
              icon: "el-icon-s-home"
            }
          ]
        },
        {
          name: "用户管理",
          icon: "el-icon-user",
          children: [
            {
              name: "用户列表",
              path: "/user",
              icon: "el-icon-s-custom"
            },
            {
              name: "充值余额",
              path: "/deposit",
              icon: "el-icon-money"
            },
            {
              name: "管理员列表",
              path: "/admin",
              icon: "el-icon-s-check"
            },
            {
              name: "评论管理",
              path: "/comment",
              icon: "el-icon-chat-line-round"
            },
            {
              name: "独特优惠",
              path: "/uniqueCoupon",
              icon: "el-icon-medal-1"
            }
          ]
        },
        {
          name: "统计分析",
          icon: "el-icon-data-line",
          children: [
            {
              name: "全量统计",
              path: "/report/allOrderStatic",
              icon: "el-icon-menu"
            },
            {
              name: "门店统计",
              path: "/report/shopOrderStatic",
              icon: "el-icon-menu"
            },
            {
              name: "机器使用率",
              path: "/report/machineUseCountStatistic",
              icon: "el-icon-menu"
            },
            // {
            //   name: "城市订单",
            //   path: "/report/cityOrderStatic",
            //   icon: "el-icon-menu"
            // },
            {
              name: "加盟商统计",
              path: "/report/vendorOrderStatic",
              icon: "el-icon-menu"
            },
            {
              name: "排名统计",
              path: "/report/rank",
              icon: "el-icon-menu"
            },
            {
              name: "用户增长",
              path: "/report/userGrowth",
              icon: "el-icon-menu"
            }
          ]
        },

        {
          name: "账单管理",
          icon: "el-icon-bank-card",
          children: [
            {
              name: "账单明细",
              path: "/billList",
              icon: "el-icon-money"
            },
            {
              name: "账单分析",
              path: "/billListStatistic",
              icon: "el-icon-mobile"
            },
            {
              name: "分账设置",
              path: "/billManagement",
              icon: "el-icon-money"
            }
          ]
        },
        {
          name: "发票管理",
          icon: "el-icon-wallet",
          children: [
            {
              name: "开票申请",
              path: "/receipt",
              icon: "el-icon-tickets"
            }
          ]
        },

        {
          name: "提现中心",
          icon: "el-icon-bank-card",
          children: [
            {
              name: "提现申请",
              path: "/withdraw",
              icon: "el-icon-money"
            }
          ]
        },
        {
          name: "营销管理",
          icon: "el-icon-s-promotion",
          children: [
            {
              name: "优惠券",
              path: "/coupon",
              icon: "el-icon-s-ticket"
            },
            {
              name: "权益卡管理",
              path: "/vip",
              icon: "el-icon-medal-1"
            },
            {
              name: "定时优惠管理",
              path: "/timediscount",
              icon: "el-icon-date"
            },
            {
              name: "广告设置",
              path: "/advertisement",
              icon: "el-icon-date"
            }
          ]
        },
        {
          name: "日志",
          icon: "el-icon-notebook-2",
          children: [
            {
              name: "日志查询",
              path: "/log",
              icon: "el-icon-notebook-1"
            }
          ]
        }
      ],
      //代理商菜单
      agentList: [
        {
          name: "订单管理",
          icon: "el-icon-files",
          children: [
            {
              name: "订单查询",
              path: "/order",
              icon: "el-icon-tickets"
            }
          ]
        },
        {
          name: "加盟管理",
          icon: "el-icon-film",
          children: [
            {
              name: "加盟管理",
              path: "/joinIn",
              icon: "el-icon-connection"
            }
          ]
        },
        {
          name: "统计分析",
          icon: "el-icon-data-line",
          children: [
            {
              name: "全量统计",
              path: "/report/allOrderStatic",
              icon: "el-icon-menu"
            },
            {
              name: "门店统计",
              path: "/report/shopOrderStatic",
              icon: "el-icon-menu"
            },
            // {
            //   name: "城市统计",
            //   path: "/report/cityOrderStatic",
            //   icon: "el-icon-menu"
            // },
            {
              name: "加盟商统计",
              path: "/report/vendorOrderStatic",
              icon: "el-icon-menu"
            },
            {
              name: "排名统计",
              path: "/report/rank",
              icon: "el-icon-menu"
            }
          ]
        },

        {
          name: "账单管理",
          icon: "el-icon-bank-card",
          children: [
            {
              name: "账单明细",
              path: "/billList",
              icon: "el-icon-money"
            },
            {
              name: "分账设置",
              path: "/billManagement",
              icon: "el-icon-money"
            }
          ]
        }
      ],
      //加盟商菜单
      vendorList: [
        {
          name: "订单管理",
          icon: "el-icon-files",
          children: [
            {
              name: "订单查询",
              path: "/order",
              icon: "el-icon-tickets"
            },

            {
              name: "退款审核",
              path: "/refund",
              icon: "el-icon-edit"
            }
          ]
        },

        {
          name: "设备管理",
          icon: "el-icon-cpu",
          children: [
            {
              name: "设备设置",
              path: "/machine",
              icon: "el-icon-printer"
            },
            {
              name: "产品绑定",
              path: "/bindproduct",
              icon: "el-icon-connection"
            },
            {
              name: "故障管理",
              path: "/fault",
              icon: "el-icon-warning"
            }
          ]
        },

        {
          name: "加盟管理",
          icon: "el-icon-film",
          children: [
            {
              name: "门店管理",
              path: "/shop",
              icon: "el-icon-s-home"
            }
          ]
        },
        {
          name: "用户管理",
          icon: "el-icon-user",
          children: [
            {
              name: "评论管理",
              path: "/comment",
              icon: "el-icon-chat-line-round"
            }
          ]
        },
        {
          name: "统计分析",
          icon: "el-icon-data-line",
          children: [
            // {
            //   name: "全量统计",
            //   path: "/report/allOrderStatic",
            //   icon: "el-icon-menu"
            // },
            {
              name: "门店统计",
              path: "/report/shopOrderStatic",
              icon: "el-icon-menu"
            }
            // {
            //   name: "城市统计",
            //   path: "/report/cityOrderStatic",
            //   icon: "el-icon-menu"
            // },
            // {
            //   name: "加盟商统计",
            //   path: "/report/vendorOrderStatic",
            //   icon: "el-icon-menu"
            // }
          ]
        },

        // {
        //   name: "分账管理",
        //   icon: "el-icon-bank-card",
        //   children: [
        //     {
        //       name: "分账查询",
        //       path: "/billManagement",
        //       icon: "el-icon-money"
        //     }
        //   ]
        // },
        {
          name: "营销管理",
          icon: "el-icon-s-promotion",
          children: [
            {
              name: "优惠券",
              path: "/coupon",
              icon: "el-icon-s-ticket"
            },
            {
              name: "权益卡管理",
              path: "/vip",
              icon: "el-icon-medal-1"
            },
            {
              name: "定时优惠管理",
              path: "/timediscount",
              icon: "el-icon-date"
            },
            {
              name: "广告设置",
              path: "/advertisement",
              icon: "el-icon-date"
            }
          ]
        },

        {
          name: "账单管理",
          icon: "el-icon-bank-card",
          children: [
            {
              name: "账单明细",
              path: "/billList",
              icon: "el-icon-money"
            }
          ]
        }
      ],
      activeMenuList: []
    };
  },
  computed: {
    activeIndex() {
      return this.$route.path;
    }
  },
  // watch: {
  //   "$store.state.userInfo": {
  //     handler: function(val) {
  //       if (val.user_type === "admin") {
  //         this.activeMenuList = this.menuList;
  //         //替换url地址为administrator
  //         for (const key in this.$urlMapping) {
  //           if (this.$urlMapping.hasOwnProperty(key)) {
  //             this.$urlMapping[key] = this.$urlMapping[key].replace(
  //               /\/api\/vendor\/|\/api\/agent\//,
  //               "/api/administrator/"
  //             );
  //           }
  //         }
  //       } else if (val.user_type === "vendor") {
  //         this.activeMenuList = this.vendorList;
  //         //替换url地址为vendor
  //         for (const key in this.$urlMapping) {
  //           if (this.$urlMapping.hasOwnProperty(key)) {
  //             this.$urlMapping[key] = this.$urlMapping[key].replace(
  //               /\/api\/administrator\/|\/api\/agent\//,
  //               "/api/vendor/"
  //             );
  //           }
  //         }
  //       } else if (val.user_type === "agent") {
  //         this.activeMenuList = this.agentList;
  //         //替换url地址为vendor
  //         for (const key in this.$urlMapping) {
  //           if (this.$urlMapping.hasOwnProperty(key)) {
  //             this.$urlMapping[key] = this.$urlMapping[key].replace(
  //               /\/api\/administrator\/|\/api\/vendor\//,
  //               "/api/agent/"
  //             );
  //           }
  //         }
  //       }
  //     },
  //     deep: true,
  //     immediate: true
  //   }
  // },

  mounted() {
    let strUserInfo = localStorage.getItem("userInfo");
    if (!strUserInfo) {
      return;
    }
    let userInfo = JSON.parse(strUserInfo);

    if (userInfo.user_type === "admin") {
      this.activeMenuList = this.menuList;
      //替换url地址为administrator
      for (const key in this.$urlMapping) {
        if (this.$urlMapping.hasOwnProperty(key)) {
          this.$urlMapping[key] = this.$urlMapping[key].replace(
            /\/api\/vendor\/|\/api\/agent\//,
            "/api/administrator/"
          );
        }
      }
    } else if (userInfo.user_type === "vendor") {
      this.activeMenuList = this.vendorList;
      //替换url地址为vendor
      for (const key in this.$urlMapping) {
        if (this.$urlMapping.hasOwnProperty(key)) {
          this.$urlMapping[key] = this.$urlMapping[key].replace(
            /\/api\/administrator\/|\/api\/agent\//,
            "/api/vendor/"
          );
        }
      }
    } else if (userInfo.user_type === "agent") {
      this.activeMenuList = this.agentList;
      //替换url地址为vendor
      for (const key in this.$urlMapping) {
        if (this.$urlMapping.hasOwnProperty(key)) {
          this.$urlMapping[key] = this.$urlMapping[key].replace(
            /\/api\/administrator\/|\/api\/vendor\//,
            "/api/agent/"
          );
        }
      }
    }
  },

  methods: {
    getMenuBgcolor() {
      if (
        process.env.VUE_APP_ENV == "dev" ||
        process.env.VUE_APP_ENV == "test"
      ) {
        return "#206BCA";
      }
      return "#545c64";
    },

    backToHome() {
      if (this.$route.name !== "home") {
        this.$router.replace({ name: "home" });
      } else {
        this.$emit("handleViewData");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.logo-container {
  height: 64px;
  background: #545c64;
  box-sizing: border-box;
  color: white;
  line-height: 64px;
  text-align: center;
  cursor: pointer;
  &:hover {
    color: #ffd04b;
  }
  .blue {
    color: #409eff;
    margin-right: 0.25rem;
    font-size: 32px;
    position: relative;
    top: 6px;
  }
}
.mask {
  padding: absolute;
  top: 0;
  left: 0;
  width: 159px;
  height: 100vh;
  background: #545c64;
}

/deep/ .el-submenu .el-menu-item {
  min-width: auto;
}

.el-menu-vertical-demo {
  width: 160px;
}

.washinglogo {
  width: 24px;
  vertical-align: middle;
  margin-right: 6px;
}
</style>
